import * as React from 'react';

const SvgFormTextAlignCenter = (props) => React.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "M5 5h14v2H5V5Zm3 4h8v2H8V9Zm8 8H8v2h8v-2ZM5 13h14v2H5v-2Z", clipRule: "evenodd" })
);

export { SvgFormTextAlignCenter as default };
//# sourceMappingURL=FormTextAlignCenter.es.js.map
